import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = {
  key: 0,
  class: "fa fa-warning"
};
export default {
  __name: 'MainHeader',
  props: {
    content: {
      type: String,
      required: true
    },
    warning: {
      type: Boolean,
      required: false,
      default: false
    },
    isBillingPageTitle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  setup(__props) {
    const props = __props;
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        class: _normalizeClass(["text-2xl font-bold", [__props.isBillingPageTitle ? 'py-0' : 'py-2']])
      }, [__props.warning ? (_openBlock(), _createElementBlock("span", _hoisted_1)) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(__props.content), 1)], 2);
    };
  }
};